/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_LinksInputs */

const en_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other links`)
};

const th_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลิงก์อื่น ๆ`)
};

const ja_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のリンク`)
};

const fr_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres liens`)
};

const es_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros enlaces`)
};

const ru_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другие ссылки`)
};

const zh_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他链接`)
};

const vi_other_links = /** @type {(inputs: Other_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết khác`)
};

/**
* | output |
* | --- |
* | "Other links" |
*
* @param {Other_LinksInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const other_links = /** @type {((inputs?: Other_LinksInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_LinksInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_other_links(inputs)
	if (locale === "ja") return ja_other_links(inputs)
	if (locale === "fr") return fr_other_links(inputs)
	if (locale === "es") return es_other_links(inputs)
	if (locale === "ru") return ru_other_links(inputs)
	if (locale === "zh") return zh_other_links(inputs)
	if (locale === "vi") return vi_other_links(inputs)
	return en_other_links(inputs)
});